export function Loading() {
  return (
    <div className="flex items-center space-x-2" aria-hidden="true">
      <span className="bg-brand h-3 w-3 animate-bounce rounded-full [animation-delay:-0.32s]" />
      <span className="bg-brand h-3 w-3 animate-bounce rounded-full [animation-delay:-0.16s]" />
      <span className="bg-brand h-3 w-3 animate-bounce rounded-full" />
    </div>
  );
}
